document.addEventListener('DOMContentLoaded', () => {
  if (window.__collectionJsInit) return;
  window.__collectionJsInit = true;

  // ——————————————————————————————
  // 0) State & Config
  // ——————————————————————————————
  window.productsMap = {};
  const ribbon_image = 'https://cdn.shopify.com/s/files/1/0871/5558/files/Customizable_Jerseys.png?v=1742860154';
  const totalProducts = window.store_total_products || 0;
  const productsPerPage = 250;
  const totalPages = Math.ceil(totalProducts / productsPerPage);

  // ——————————————————————————————
  // 1) Fetch all products (to mark “customjersey” ones)
  // ——————————————————————————————
  function fetchProductsFromApi(page) {
    const url = `https://soccerwearhouse.com/collections/customized-products/products.json?limit=${productsPerPage}&page=${page}`;
    fetch(url)
      .then(res => res.json())
      .then(data => {
        data.products.forEach(product => {
          if (product.tags && product.tags.includes('customjersey')) {
            const h = product.handle;
            if (!window.productsMap[h]) {
              window.productsMap[h] = { handle: h };
            }
          }
        });
        if (page < totalPages) {
          fetchProductsFromApi(page + 1);
        } else {
          document.querySelectorAll('.ss__result--item').forEach(addRibbon);
        }
      })
      .catch(err => console.error('Error fetching products:', err));
  }

  // ——————————————————————————————
  // 2) Slick slider init
  // ——————————————————————————————
  if (typeof $ !== 'undefined' && typeof $.fn.slick === 'function') {
    $('.featured-collections-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        { breakpoint: 899, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ]
    });
  }

  // ——————————————————————————————
  // 3) Labels, CTA, ribbon & canonical
  // ——————————————————————————————
  function addDiscountLabel(detail) {
    const msrpEl  = detail.querySelector('.ss__result__msrp');
    const saleEl  = detail.querySelector('.ss__result__price--on-sale');
    const pricing = detail.querySelector('.ss__result__pricing');
    const imgWrap = detail.closest('.ss__result__inner')?.querySelector('.ss__result__image__wrapper');
    if (!msrpEl || !saleEl || !pricing || !imgWrap) return;

    const msrp      = parseFloat(msrpEl.textContent.replace('$','')) || 0;
    const salePrice = parseFloat(saleEl.textContent.replace('$','')) || 0;
    const savings   = Math.ceil(msrp - salePrice);

    let labelText;
    if (salePrice > 75) {
      labelText = `Save $${savings}`;
    } else {
      const pct = Math.round((savings / msrp) * 100);
      labelText = `${pct}% off`;
    }

    if (!detail.querySelector('.ss_discount_label_text')) {
      const txt = document.createElement('p');
      txt.classList.add('ss_discount_label_text');
      txt.textContent = labelText;
      pricing.insertAdjacentElement('afterend', txt);
    }
    if (!detail.querySelector('.ss_discount_label')) {
      const tag = document.createElement('p');
      tag.classList.add('ss_discount_label');
      tag.textContent = 'Sale';
      imgWrap.insertAdjacentElement('afterend', tag);
    }
  }

  function addCta(item) {
    const imgLink = item.querySelector('.ss__result__image__link');
    if (!imgLink || item.querySelector('.ss_cta_button')) return;

    // derive canonical href
    const raw = imgLink.getAttribute('href') || '';
    const m = raw.match(/\/products\/([^\/\?]+)/);
    const href = m ? `/products/${m[1]}` : raw;

    const btn = document.createElement('a');
    btn.classList.add('ss_cta_button', 'custom_btn');
    btn.textContent = 'Shop Now';
    btn.setAttribute('href', href);
    item.appendChild(btn);
  }

  function addRibbon(item) {
    const link = item.querySelector('.ss__result__image__link');
    if (!link) return;
    const handle = link.getAttribute('href').split('/products/')[1]?.split('?')[0];
    if (handle && window.productsMap[handle] && !item.querySelector('.ribbon')) {
      const r = document.createElement('div');
      r.classList.add('ribbon', 'ribbon-top-left');
      r.setAttribute('data-label', 'Customizable');
      item.appendChild(r);
    }
  }

  function rewriteToCanonical(item) {
    // 1) image link
    const imgLink = item.querySelector('.ss__result__image__link');
    if (imgLink) {
      const m = (imgLink.getAttribute('href') || '').match(/\/products\/([^\/\?]+)/);
      if (m) imgLink.setAttribute('href', `/products/${m[1]}`);
    }

    // 2) title link (if you have .ss__result__title)
    const titleLink = item.querySelector('.ss__result__title a');
    if (titleLink) {
      const m = (titleLink.getAttribute('href') || '').match(/\/products\/([^\/\?]+)/);
      if (m) titleLink.setAttribute('href', `/products/${m[1]}`);
    }

    // 3) name link (for .ss__result__name)
    const nameLink = item.querySelector('.ss__result__name a');
    if (nameLink) {
      const m = (nameLink.getAttribute('href') || '').match(/\/products\/([^\/\?]+)/);
      if (m) nameLink.setAttribute('href', `/products/${m[1]}`);
    }
  }

  // initial canonical pass
  document.querySelectorAll('.ss__result--item').forEach(rewriteToCanonical);

  // ensure future items get canonical href
  new MutationObserver(muts => {
    muts.forEach(m => m.addedNodes.forEach(n => {
      if (n.nodeType === 1 && n.matches('.ss__result--item')) {
        rewriteToCanonical(n);
      }
    }));
  }).observe(document.body, { childList: true, subtree: true });

  // ——————————————————————————————
  // 4) Observe for dynamic injection
  // ——————————————————————————————
  function observeResultsContainer() {
    const obs = new MutationObserver(muts => {
      muts.forEach(m => m.addedNodes.forEach(n => {
        if (n.nodeType === 1 && n.classList.contains('ss__results')) {
          observeResultsContent(n);
        }
      }));
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  function observeResultsContent(container) {
    const contentObs = new MutationObserver(muts => {
      muts.forEach(m => {
        if (m.type === 'childList') {
          m.addedNodes.forEach(n => {
            if (n.nodeType === 1) {
              if (n.classList.contains('ss__result__details')) {
                addDiscountLabel(n);
              }
              if (n.classList.contains('ss__result--item')) {
                addCta(n);
                addRibbon(n);
                rewriteToCanonical(n);
              }
            }
          });
        }
      });
    });
    contentObs.observe(container, { childList: true, subtree: true });
  }

  function waitForElement(selector, cb) {
    const obs = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        cb(el);
        obs.disconnect();
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  // ——————————————————————————————
  // 5) Initialize and fetch
  // ——————————————————————————————
  observeResultsContainer();
  waitForElement('.ss__results', () => {
    document.querySelectorAll('.ss__result__details').forEach(addDiscountLabel);
    document.querySelectorAll('.ss__result--item').forEach(item => {
      addCta(item);
      addRibbon(item);
      rewriteToCanonical(item);
    });
  });
  fetchProductsFromApi(1);

  // ——————————————————————————————
  // 6) Filter bar badge dropdowns
  // ——————————————————————————————
  function initFilterBar() {
    const filterBar = document.querySelector('[data-filter-bar]');
    if (!filterBar) return;

    const isMobileFilterBar = () => window.matchMedia('(max-width: 798px)').matches;

    // On mobile, .filter-bar__inner has -webkit-overflow-scrolling: touch for
    // momentum scroll. Real iOS Safari has a long-standing WebKit quirk where
    // position:fixed descendants of such a container are NOT escaped to the
    // viewport — they stay painted inside that scrolling layer and get clipped
    // anyway. (Chrome's mobile emulation doesn't reproduce this, which is why
    // it can look fixed in devtools but stay broken on a real iPhone.)
    // CSS alone can't fix this — the panel has to actually leave the DOM
    // subtree, so we portal it to <body> while open and restore it on close.
    const panelHomes = new WeakMap();
    let openedAtScrollY = 0;

    function positionPanelFixed(btn, panel) {
      const rect = btn.getBoundingClientRect();
      const maxLeft = window.innerWidth - panel.offsetWidth - 16;
      panel.style.top = `${rect.bottom + 6}px`;
      panel.style.left = `${Math.max(16, Math.min(rect.left, maxLeft))}px`;
    }

    function unportalPanel(panel) {
      const home = panelHomes.get(panel);
      if (!home) return;
      home.parent.insertBefore(panel, home.next);
      panelHomes.delete(panel);
      panel.classList.remove('filter-badge__panel--portaled', 'sort-dropdown--portaled');
      panel.style.top = '';
      panel.style.left = '';
    }

    function closeAllDropdowns() {
      filterBar.querySelectorAll('[data-filter-badge].is-open').forEach(b => {
        b.classList.remove('is-open');
        b.querySelector('[data-filter-badge-btn]')?.setAttribute('aria-expanded', 'false');
      });
      filterBar.querySelector('.sort-wrapper.is-open')?.classList.remove('is-open');
      document.querySelectorAll('.filter-badge__panel--portaled, .sort-dropdown--portaled').forEach(unportalPanel);
    }

    // Filter badge dropdowns
    filterBar.querySelectorAll('[data-filter-badge]').forEach(badge => {
      const btn = badge.querySelector('[data-filter-badge-btn]');
      const panel = badge.querySelector('[data-filter-badge-panel]');
      if (!btn || !panel) return;

      btn.addEventListener('click', e => {
        e.stopPropagation();
        const isOpen = badge.classList.contains('is-open');
        closeAllDropdowns();
        if (!isOpen) {
          badge.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          if (isMobileFilterBar()) {
            openedAtScrollY = window.scrollY;
            panelHomes.set(panel, { parent: panel.parentNode, next: panel.nextSibling });
            document.body.appendChild(panel);
            panel.classList.add('filter-badge__panel--portaled');
            positionPanelFixed(btn, panel);
          }
        }
      });

      // Auto-submit on checkbox change
      panel.querySelectorAll('.filter-badge__checkbox').forEach(cb => {
        cb.addEventListener('change', () => {
          const form = filterBar.querySelector('[data-faceted-filter-form]');
          if (form) form.submit();
        });
      });
    });

    // Sort wrapper dropdown toggle
    const sortWrapper = filterBar.querySelector('.sort-wrapper');
    if (sortWrapper) {
      const sortToggle = sortWrapper.querySelector('[data-sort-toggle]');
      const sortDropdown = sortWrapper.querySelector('[data-sort-dropdown]');
      const sortSelect = sortWrapper.querySelector('[data-sort-by]');

      if (sortToggle && sortDropdown) {
        sortToggle.addEventListener('click', e => {
          e.stopPropagation();
          const isOpen = sortWrapper.classList.contains('is-open');
          closeAllDropdowns();
          if (!isOpen) {
            sortWrapper.classList.add('is-open');
            if (isMobileFilterBar()) {
              openedAtScrollY = window.scrollY;
              panelHomes.set(sortDropdown, { parent: sortDropdown.parentNode, next: sortDropdown.nextSibling });
              document.body.appendChild(sortDropdown);
              sortDropdown.classList.add('sort-dropdown--portaled');
              positionPanelFixed(sortToggle, sortDropdown);
            }
          }
        });

        sortDropdown.querySelectorAll('[data-sort-value]').forEach(optBtn => {
          optBtn.addEventListener('click', () => {
            const value = optBtn.dataset.sortValue;
            if (sortSelect) {
              sortSelect.value = value;
              sortSelect.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              const url = new URL(window.location.href);
              url.searchParams.set('sort_by', value);
              window.location.href = url.toString();
            }
          });
        });
      }
    }

    // Close on outside click (portaled panels live outside [data-filter-bar],
    // so they need their own check)
    document.addEventListener('click', e => {
      if (
        !e.target.closest('[data-filter-bar]') &&
        !e.target.closest('.filter-badge__panel--portaled') &&
        !e.target.closest('.sort-dropdown--portaled')
      ) {
        closeAllDropdowns();
      }
    });

    // Close on page scroll — a fixed-position panel (mobile) would otherwise
    // stay put while the trigger button scrolls away underneath it.
    // iOS Safari's bottom toolbar auto-collapses on interaction near the
    // bottom of the viewport, and that resize fires a genuine window scroll
    // event — with no threshold, tapping an option low in an open panel could
    // trigger this listener and close the panel out from under that same tap.
    // Only treat it as "user scrolled away" once the page has actually moved
    // a real distance from where it was when the panel opened.
    window.addEventListener('scroll', () => {
      if (Math.abs(window.scrollY - openedAtScrollY) < 60) return;
      closeAllDropdowns();
    }, { passive: true });

    // Close on Escape
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeAllDropdowns();
    });

    // Clear-all, chips, and clear links navigate naturally (full page reload keeps filter-bar state correct)
  }

  initFilterBar();

  // ── Sublisting scroll arrows ──
  document.querySelectorAll('[data-sublisting-scroll]').forEach(outer => {
    const scroller = outer.querySelector('.collection-sublisting');
    const prevBtn  = outer.querySelector('[data-sublisting-scroll-prev]');
    const nextBtn  = outer.querySelector('[data-sublisting-scroll-next]');
    if (!scroller || !prevBtn || !nextBtn) return;

    const SCROLL_AMOUNT = 300;

    function updateSublistingArrows() {
      const atStart = scroller.scrollLeft <= 2;
      const atEnd   = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 2;
      prevBtn.setAttribute('aria-hidden', atStart ? 'true' : 'false');
      nextBtn.setAttribute('aria-hidden', atEnd   ? 'true' : 'false');
    }

    prevBtn.addEventListener('click', () => {
      scroller.scrollBy({ left: -SCROLL_AMOUNT, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', () => {
      scroller.scrollBy({ left: SCROLL_AMOUNT, behavior: 'smooth' });
    });
    scroller.addEventListener('scroll', updateSublistingArrows, { passive: true });

    updateSublistingArrows();
  });

  // ── Badge scroll arrows ──
  document.querySelectorAll('[data-badge-scroll]').forEach(outer => {
    const scroller = outer.querySelector('.collection-below-h1');
    const prevBtn  = outer.querySelector('[data-badge-scroll-prev]');
    const nextBtn  = outer.querySelector('[data-badge-scroll-next]');
    if (!scroller || !prevBtn || !nextBtn) return;

    const SCROLL_AMOUNT = 200;

    function updateArrows() {
      const atStart = scroller.scrollLeft <= 2;
      const atEnd   = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 2;
      prevBtn.setAttribute('aria-hidden', atStart ? 'true' : 'false');
      nextBtn.setAttribute('aria-hidden', atEnd   ? 'true' : 'false');
    }

    prevBtn.addEventListener('click', () => {
      scroller.scrollBy({ left: -SCROLL_AMOUNT, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', () => {
      scroller.scrollBy({ left: SCROLL_AMOUNT, behavior: 'smooth' });
    });
    scroller.addEventListener('scroll', updateArrows, { passive: true });

    updateArrows();
  });
});
